<template>
  <NuxtLayout name="funnel">
    <ConnectifTag name="Pagina_Ficha" />
    <ConnectifTag name="Contenido_Transaccional" />
    <ConnectifCategory :name="province" />
    <CottageContactWhatsApp
      v-if="cottageContactWhatsAppPage"
      :cottage-contact-whats-app-page="cottageContactWhatsAppPage"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { CottageContactWhatsAppPage } from '~/modules/views/cottage-contact-whatsapp/entities/CottageContactWhatsAppPage'

import type { HeadInfo } from '~/modules/head/entities/HeadInfo'
import { useHeadInfoComposable } from '~/modules/head/composables/useHeadInfoComposable'
import {
  sendConnectifPageView,
  sendConnectifProductView,
} from '~/modules/integrations/connectif/composables/useConnectifComposable'
import useToConnectifProduct from '~/modules/integrations/connectif/composables/transformers/useToConnectifProduct'

const { setHeadInfo } = useHeadInfoComposable()

const route = useRoute()

definePageMeta({
  menuLogoBackHideLink: true,
})

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const setTitle = (cottage: CottageContactWhatsAppPage): string => {
  return t('views.cottage-contact-whatsapp.seo.title', { name: cottage.name })
}

const slug = route.params.slug as string
const province = route.params.province as string

const paramsCottage = { slug, province }

let cottageContactWhatsAppPage: CottageContactWhatsAppPage | null = null

const { data: cottageData } = await useFetch(
  '/__nuxt-api/rurality/v3/cottages/detail',
  {
    body: paramsCottage,
    method: 'POST',
  },
)

if (cottageData.value) {
  if (cottageData.value.success) {
    const getCottageCall = cottageData.value.success.data

    const paramsOwner = {
      id: getCottageCall.owner.id,
    }
    const { data: ownerData } = await useFetch(
      '/__nuxt-api/rurality/v3/owners/detail',
      {
        body: paramsOwner,
        method: 'POST',
      },
    )

    if (ownerData.value) {
      if (ownerData.value.success) {
        cottageContactWhatsAppPage = {
          ...getCottageCall,
          owner: ownerData.value.success.data,
        }
        const cottageHeadInfo: HeadInfo = {
          title: setTitle(cottageContactWhatsAppPage),
        }
        setHeadInfo(cottageHeadInfo)
        sendConnectifPageView()
        sendConnectifProductView(
          useToConnectifProduct(cottageContactWhatsAppPage),
        )
      } else if (ownerData.value.error) {
        showErrorPage(ownerData.value.error as ApiResponseError)
      }
    }
  } else if (cottageData.value.error) {
    showErrorPage(cottageData.value.error as ApiResponseError)
  }
}
</script>
